import React from 'react';

import AppModal from '../../../ui-components/AppModal';
import StateForm from './StateForm';

interface StateFormModalProps {
  isOpen: boolean;
  mode: 'create' | 'edit';
  stateId?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

const StateFormModal: React.FC<StateFormModalProps> = ({
  isOpen,
  mode,
  stateId,
  onClose,
  onSuccess,
}) => {
  return (
    <AppModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit State' : 'Add State'}
      description={
        mode === 'create'
          ? 'Create a new State'
          : 'Update existing State information'
      }
      onClose={onClose}
      hideFooter
      variant="form"
      maxWidth="max-w-3xl"
      closeOnOverlayClick
    >
      <StateForm
        embedded
        stateId={stateId}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </AppModal>
  );
};

export default StateFormModal;
